import { watch, type Ref } from "vue";

/** Keep match offsets current before the highlight renderer's next animation frame. */
export const useBannedWordChecks = (
  editor: Ref<any>,
  words: Ref<string[]>,
  check: (quill: any) => void,
) => {
  watch(editor, (quill, _previous, onCleanup) => {
    if (!quill) return;
    const onEditorChange = (event: string) => {
      // Includes paste, undo and silent restores. Debouncing leaves the renderer
      // using old offsets against new text, so later underlines jump while typing.
      if (event === "text-change") check(quill);
    };
    quill.on("editor-change", onEditorChange);
    check(quill);
    onCleanup(() => quill.off("editor-change", onEditorChange));
  }, { immediate: true, flush: "post" });

  watch(() => words.value.join("\0"), () => {
    if (editor.value) check(editor.value);
  }, { flush: "post" });
};
